<template>
  <div>
    <!-- ACTION CARD -->
    <div class="card mb-3">
      <div class="card-body">
        <span class="me-2">Changer à :</span>

        <button
          v-if="userData?.stock_ready === 0"
          class="btn btn-success"
          @click="saveColiStock"
        >
          Prêt pour la préparation
        </button>

        <button
          v-if="userData?.stock_ready === 1"
          class="btn btn-primary"
          @click="saveColiStock"
        >
          Nouveau Colis
        </button>
      </div>
    </div>

    <!-- DESTINATAIRE INFO -->
    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0">Information du destinataire</h5>
      </div>

      <div class="card-body">
        <div class="row text-center">
          <div
            class="col-md-2 mb-2"
            v-for="item in receiverInfo"
            :key="item.label"
          >
            <div class="card back h-100">
              <div class="card-body">
                <feather-icon :icon="item.icon" size="24" />
                <div class="fw-bold mt-2">{{ item.label }}</div>
                <div class="text">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-3">
          <button class="btn btn-primary" @click="goToEdit">Modifier</button>
        </div>
      </div>
    </div>

    <!-- TABLES -->
    <div class="row">
      <!-- PRODUITS EN STOCK -->
      <div class="col-md-6 mb-3" v-if="userData?.stock_ready === 0">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">Produits En Stock</h5>
          </div>

          <div class="card-body">
            <vue-good-table :columns="columns" :rows="products">
              <template #table-row="{ row, column }">
                <template v-if="column.field === 'var_name'">
                  <strong>{{ row.var_name }}</strong> :
                  <span class="badge bg-secondary">{{ row.qty }}</span>
                </template>

                <template v-else-if="column.field === 'product_pic'">
                  <img
                    v-if="row.product_pic"
                    :src="row.product_pic"
                    class="rounded-circle me-15"
                    style="width: 30px; height: 30px; object-fit: cover"
                  />
                  <img
                    v-else
                    :src="require('@/assets/images/NoImage.png')"
                    class="rounded-circle me-15"
                    style="width: 30px; height: 30px; object-fit: cover"
                  />
                </template>

                <template v-else-if="column.field === 'action'">
                  <div class="d-flex gap-2">
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model.number="row.value"
                      :max="row.qty"
                      min="1"
                      style="width: 80px"
                    />
                    <button
                      class="btn btn-sm btn-primary"
                      @click="addQuantity(row)"
                    >
                      <i class="flaticon flaticon-diskette"></i>
                    </button>
                  </div>
                </template>

                <template v-else>
                  {{ row[column.field] }}
                </template>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>

      <!-- PRODUITS DU COLIS -->
      <div class="col-md-6 mb-3">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">Liste des produits du colis</h5>
          </div>

          <div class="card-body">
            <vue-good-table
              :columns="columns2"
              :rows="userData?.ProdParcels || []"
            >
              <template #table-row="{ row, column }">
                <template
                  v-if="
                    column.field === 'action' && userData?.stock_ready === 0
                  "
                >
                  <div class="d-flex gap-2">
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model.number="row.value"
                      :max="row.qnty"
                      min="1"
                      style="width: 80px"
                    />
                    <button
                      class="btn btn-sm btn-danger"
                      @click="removeQuantity(row)"
                    >
                      <i class="flaticon flaticon-delete"></i>
                    </button>
                  </div>
                </template>
                <template v-else-if="column.field === 'product_pic'">
                  <img
                    v-if="row.product_pic"
                    :src="row.product_pic"
                    class="rounded-circle me-15"
                    style="width: 30px; height: 30px; object-fit: cover"
                  />
                  <img
                    v-else
                    :src="require('@/assets/images/NoImage.png')"
                    class="rounded-circle me-15"
                    style="width: 30px; height: 30px; object-fit: cover"
                  />
                </template>
                <template v-else-if="column.field === 'var_name'">
                  <strong>{{ row.variant_name }}</strong> :
                  <span class="badge bg-secondary">{{ row.qnty }}</span>
                </template>

                <template v-else>
                  {{ row[column.field] }}
                </template>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script  lang="ts">
import { ref, computed, onMounted, watch, defineProps } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import api from "@/utils/axios";
import { defineComponent } from "vue";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "EditProdColis",
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  setup: (props) => {
    /* =======================
   TYPES
======================= */
    interface Product {
      id: number;
      product_pic: string;
      product_name: string;
      agency_name?: string;
      stock_agency_name?: string;
      var_name: string;
      qty?: number;
      qnty?: number;
      value?: number;
      inventory_id?: number;
    }

    interface Parcel {
      id: number;
      code: string;
      receiver: string;
      phone: string;
      city_name: string;
      address: string;
      note?: string;
      price: number;
      stock_ready: number;
      ProdParcels: Product[];
    }

    /* =======================
   ROUTER
======================= */
    const router = useRouter();

    /* =======================
   STATE
======================= */
    const products = ref<Product[]>([]);
    const userData = ref<Parcel | null>(null);

    /* =======================
   TABLE COLUMNS
======================= */
    const columns = [
      { label: "", field: "product_pic" },
      { label: "Nom du produit", field: "product_name" },
      { label: "Agence", field: "agency_name" },
      { label: "Quantité", field: "var_name" },
      { label: "Actions", field: "action" },
    ];

    const columns2 = [
      { label: "", field: "product_pic" },
      { label: "Nom du produit", field: "product_name" },
      { label: "Agence", field: "stock_agency_name" },
      { label: "Quantité", field: "var_name" },
      { label: "Actions", field: "action" },
    ];

    const { showToast } = useAppToast();

    /* =======================
   COMPUTED
======================= */
    const receiverInfo = computed(() => {
      if (!userData.value) return [];

      return [
        {
          label: "Destinataire",
          icon: "UserIcon",
          value: userData.value.receiver,
        },
        { label: "Téléphone", icon: "PhoneIcon", value: userData.value.phone },
        { label: "Ville", icon: "HomeIcon", value: userData.value.city_name },
        { label: "Adresse", icon: "MapPinIcon", value: userData.value.address },
        {
          label: "Commentaire",
          icon: "FileIcon",
          value: userData.value.note ?? "",
        },
        {
          label: "Prix",
          icon: "DollarSignIcon",
          value: `${userData.value.price} Dhs`,
        },
      ];
    });

    /* =======================
   METHODS
======================= */
    const loadData = async (): Promise<void> => {
      try {
        console.log("Loading data for colis id:", props.id);

        const [prodRes, parcelRes] = await Promise.all([
          api.get<Product[]>(`/api/auth/client/InventoryProduct`),
          api.get<{ data: Parcel }>(
            `/api/auth/client/ParcelStock?parcel_id=${props.id}`
          ),
        ]);

        products.value = prodRes.data;
        userData.value = parcelRes.data.data;
      } catch (error) {
        Swal.fire("Erreur", "Impossible de charger les données", "error");
      }
    };

    const addQuantity = async (row: Product): Promise<void> => {
      try {
        const res = await api.post(`/api/auth/client/AddVariantParcel`, {
          colis_id: props.id,
          qnty: row.value,
          variantId: row.id,
        });
        if (res.data.message === "success") {
          showToast( "Produit ajouté", "success");
          loadData();
        } else if (res.data.message === "erro agency") {
          showToast("Vous pouvez pas ajouter ce produits, Pas dans la même agence de reception !", "error");
        } else {
          showToast(res.data.message ?? "Un erreur est survenue", "error");
        }
      } catch {
        Swal.fire("Erreur", "Ajout impossible", "error");
      }
    };

    const removeQuantity = async (row: Product): Promise<void> => {
      try {
        console.log(row);
        await api.post(`/api/auth/client/RemoveVariantParcel`, {
          colis_id: props.id,
          qnty: row.value,
          content_id: row.id,
          agency_var_name: row.agency_name,
          inventory_id: row.inventory_id,
        });

        Swal.fire("Succès", "Produit supprimé", "success");
        loadData();
      } catch {
        Swal.fire("Erreur", "Suppression impossible", "error");
      }
    };

    const saveColiStock = async (): Promise<void> => {
      try {
        await api.post(`/api/auth/client/SaveColiStock`, {
          colis_id: props.id,
        });

        Swal.fire("Succès", "Statut mis à jour", "success");
        loadData();
      } catch {
        Swal.fire("Erreur", "Mise à jour impossible", "error");
      }
    };

    const goToEdit = (): void => {
      if (!userData.value) return;

      router.push(`/edit-colis/${userData.value.id}/${userData.value.code}`);
    };

    /* =======================
   LIFECYCLE
======================= */
    onMounted(loadData);

    watch(
      () => props.id,
      () => loadData()
    );

    return {
      products,
      userData,
      columns,
      columns2,
      receiverInfo,
      addQuantity,
      removeQuantity,
      saveColiStock,
      goToEdit,
    };
  },
});
</script>
<style scoped>
.back {
  background-color: #dcdcdc;
  width: 180px;
}
.text {
  color: red;
  font-size: 16px;
}
</style>
